import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFeaturedProperties } from "../../redux/action/featured";
import { Link, useNavigate } from "react-router-dom";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Chip,
  Box,
} from "@mui/material";
import "./index.css";
import { BedDoubleIcon } from "lucide-react";
import { Bathroom, Business, Language } from "@mui/icons-material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { Watermark } from "@hirohe/react-watermark";

const FeaturedRent = () => {
  const { featuredProperties } = useSelector((state) => state.featured);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  console.log(featuredProperties, "featured");
  useEffect(() => {
    dispatch(getFeaturedProperties(""));
  }, []);

  const handleContact = (id, property) => {
    !property.route_title
      ? window.open(`/properties/${id}`, "_blank")
      : window.open(`/properties/${id}?id=${property._id}`, "_blank");
  };

  // Filter properties for rent
  const propertiesForRent = featuredProperties.filter(property => property.wantto === "rent");
  const propertiesForSale = featuredProperties.filter(property => property.wantto === "sell");

  const getPropertiesInitial = () => {
    try {
      const data = {
        priceRange: [1, 10000000],
      };

      let query = `?`;
      Object.keys(data).forEach((key, idx) => {
        if (Array.isArray(data[key])) {
          data[key].forEach((item, index) => {
            query += `${idx > 0 || index > 0 ? "&" : ""}${key}=${item}`;
          });
        } else {
          query += `${idx > 0 ? "&" : ""}${key}=${data[key]}`;
        }
      });
      if (query !== undefined) {
        dispatch(getFeaturedProperties(query));
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getPropertiesInitial();
  }, []);

  // Fallback if no properties are available
  if (propertiesForRent.length === 0) {
    return <p>No properties available for rent at this time.</p>;
  }



  const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <Box
        onClick={onClick}
        sx={{
          position: "absolute",
          top: "50%",
          left: "-4%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          zIndex: 1,
          color: "#fff",
          display: isMobile ? "none" : "flex",
          backgroundColor: "#f9dbdb",
          borderRadius: "50%",
          padding: "10px",
          "&:hover": { backgroundColor: "#c5c6c6" },
        }}
      >
        <FaAngleLeft color="black" size={24} />
      </Box>
    );
  };
  
  const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <Box
        onClick={onClick}
        sx={{
          position: "absolute",
          top: "50%",
          right: "-4%",
          transform: "translateY(-50%)",
          display: isMobile ? "none" : "flex",
          cursor: "pointer",
          zIndex: 1,
          color: "#fff",
          backgroundColor: "#f9dbdb",
          borderRadius: "50%",
          padding: "10px",
          "&:hover": { backgroundColor: "#c5c6c6 " },
        }}
      >
        <FaAngleRight color="black" size={24} />
      </Box>
    );
  };



  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow />, // Custom Previous Arrow
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1024, // Screen size below 1024px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600, // Screen size below 600px
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
    
    <section className="responsive-padding">
      <div style={{ textAlign: "center" }}>
        <Typography variant="h4" style={{ color: "black", fontWeight: "bold" }}>
          Featured Properties for Sale
        </Typography>
        <Typography style={{ color: "#7d8597", fontSize: "16px" }}>
          Hand-Picked selection of quality places
        </Typography>
        
        <hr
          style={{
            borderBottom: "2px solid #B90000",
            width: "16px",
            margin: "0 auto",
            marginTop: "8px",
            borderRadius: "30px",
          }}
        />
      </div>

      <Slider autoplay {...settings}>
        {propertiesForSale.slice(0, 6).map((property) => (
          <Grid item key={property.id} xs={12} md={4} lg={4}>
            {" "}
            {/* Set consistent width */}
            <Card
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%", // Ensure card takes full height
                borderRadius: "10px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
                margin:"10px"
              }}
              onClick={() =>
                handleContact(property?.route_title || property._id, property)
              }
            >
              <div style={{ position: "relative" }}>
              <Watermark
                  gutter={60}
                  rotate={0}
                  text="Gharwalah.com"
                  textSize={20}
                  multiline={false}
                >
                <CardMedia
                  component="img"
                  image={property?.image}
                  // alt={
                  //   property?.title +
                  //   " " +
                  //   property?.propertyType +
                  //   " for " +
                  //   property?.wantto +
                  //   " " +
                  //   property?.locality?.coordinates[2]
                  // }
                  style={{
                    height: "200px",
                    objectFit: "cover",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }}
                />
                </Watermark>

                <div className="badge-chip">
                  <Chip
                    style={{
                      color: "white",
                      backgroundColor: "#b90000",
                      fontSize: "12px",
                    }}
                    label={property?.propertyType.toUpperCase()}
                  />
                </div>

                <div className="stars">
                  <svg
                    width="123"
                    height="18"
                    viewBox="0 0 123 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1232_2450)">
                      <path
                        d="M103.2 15.168C102.659 15.168 102.15 15.0747 101.674 14.888C101.198 14.692 100.783 14.4167 100.428 14.062C100.083 13.698 99.8307 13.2733 99.672 12.788L100.792 12.312C100.988 12.8253 101.305 13.2267 101.744 13.516C102.192 13.796 102.677 13.936 103.2 13.936C103.629 13.936 104.007 13.8427 104.334 13.656C104.67 13.46 104.931 13.194 105.118 12.858C105.305 12.5127 105.398 12.13 105.398 11.71C105.398 11.2713 105.3 10.884 105.104 10.548C104.917 10.212 104.661 9.95067 104.334 9.764C104.007 9.568 103.634 9.47 103.214 9.47C102.785 9.47 102.393 9.568 102.038 9.764C101.683 9.96 101.427 10.2073 101.268 10.506L100.162 10.268L100.96 4.57H106.364V5.76H101.478L102.01 5.228L101.394 9.652L100.918 9.372C101.226 8.98 101.585 8.7 101.996 8.532C102.416 8.35467 102.869 8.266 103.354 8.266C104.035 8.266 104.633 8.42 105.146 8.728C105.659 9.036 106.061 9.44667 106.35 9.96C106.639 10.4733 106.784 11.0567 106.784 11.71C106.784 12.3633 106.625 12.9513 106.308 13.474C106 13.9967 105.575 14.412 105.034 14.72C104.502 15.0187 103.891 15.168 103.2 15.168ZM109.167 15V13.32H110.525V15H109.167ZM117.152 15.168C116.322 15.168 115.594 14.944 114.968 14.496C114.352 14.0387 113.872 13.4087 113.526 12.606C113.181 11.794 113.008 10.8513 113.008 9.778C113.008 8.70467 113.181 7.76667 113.526 6.964C113.872 6.152 114.352 5.522 114.968 5.074C115.584 4.626 116.308 4.402 117.138 4.402C117.969 4.402 118.692 4.626 119.308 5.074C119.924 5.522 120.405 6.152 120.75 6.964C121.105 7.76667 121.282 8.70467 121.282 9.778C121.282 10.8513 121.11 11.794 120.764 12.606C120.419 13.418 119.934 14.048 119.308 14.496C118.692 14.944 117.974 15.168 117.152 15.168ZM117.152 13.894C117.712 13.894 118.198 13.726 118.608 13.39C119.019 13.0447 119.336 12.564 119.56 11.948C119.794 11.332 119.91 10.6087 119.91 9.778C119.91 8.94733 119.794 8.224 119.56 7.608C119.336 6.992 119.014 6.516 118.594 6.18C118.184 5.844 117.698 5.676 117.138 5.676C116.578 5.676 116.093 5.844 115.682 6.18C115.272 6.516 114.95 6.992 114.716 7.608C114.492 8.224 114.38 8.94733 114.38 9.778C114.38 10.5993 114.492 11.318 114.716 11.934C114.95 12.55 115.272 13.0307 115.682 13.376C116.102 13.7213 116.592 13.894 117.152 13.894Z"
                        fill="#8A909A"
                      />
                    </g>
                    <path
                      d="M7.08203 2.24219C7.41016 1.58594 8.33984 1.61328 8.64062 2.24219L10.4453 5.87891L14.4375 6.45312C15.1484 6.5625 15.4219 7.4375 14.9023 7.95703L12.0312 10.7734L12.7148 14.7383C12.8242 15.4492 12.0586 15.9961 11.4297 15.668L7.875 13.7812L4.29297 15.668C3.66406 15.9961 2.89844 15.4492 3.00781 14.7383L3.69141 10.7734L0.820312 7.95703C0.300781 7.4375 0.574219 6.5625 1.28516 6.45312L5.30469 5.87891L7.08203 2.24219Z"
                      fill="#FCAF3D"
                    />
                    <path
                      d="M26.082 2.24219C26.4102 1.58594 27.3398 1.61328 27.6406 2.24219L29.4453 5.87891L33.4375 6.45312C34.1484 6.5625 34.4219 7.4375 33.9023 7.95703L31.0312 10.7734L31.7148 14.7383C31.8242 15.4492 31.0586 15.9961 30.4297 15.668L26.875 13.7812L23.293 15.668C22.6641 15.9961 21.8984 15.4492 22.0078 14.7383L22.6914 10.7734L19.8203 7.95703C19.3008 7.4375 19.5742 6.5625 20.2852 6.45312L24.3047 5.87891L26.082 2.24219Z"
                      fill="#FCAF3D"
                    />
                    <path
                      d="M45.082 2.24219C45.4102 1.58594 46.3398 1.61328 46.6406 2.24219L48.4453 5.87891L52.4375 6.45312C53.1484 6.5625 53.4219 7.4375 52.9023 7.95703L50.0312 10.7734L50.7148 14.7383C50.8242 15.4492 50.0586 15.9961 49.4297 15.668L45.875 13.7812L42.293 15.668C41.6641 15.9961 40.8984 15.4492 41.0078 14.7383L41.6914 10.7734L38.8203 7.95703C38.3008 7.4375 38.5742 6.5625 39.2852 6.45312L43.3047 5.87891L45.082 2.24219Z"
                      fill="#FCAF3D"
                    />
                    <path
                      d="M64.082 2.24219C64.4102 1.58594 65.3398 1.61328 65.6406 2.24219L67.4453 5.87891L71.4375 6.45312C72.1484 6.5625 72.4219 7.4375 71.9023 7.95703L69.0312 10.7734L69.7148 14.7383C69.8242 15.4492 69.0586 15.9961 68.4297 15.668L64.875 13.7812L61.293 15.668C60.6641 15.9961 59.8984 15.4492 60.0078 14.7383L60.6914 10.7734L57.8203 7.95703C57.3008 7.4375 57.5742 6.5625 58.2852 6.45312L62.3047 5.87891L64.082 2.24219Z"
                      fill="#FCAF3D"
                    />
                    <path
                      d="M83.082 2.24219C83.4102 1.58594 84.3398 1.61328 84.6406 2.24219L86.4453 5.87891L90.4375 6.45312C91.1484 6.5625 91.4219 7.4375 90.9023 7.95703L88.0312 10.7734L88.7148 14.7383C88.8242 15.4492 88.0586 15.9961 87.4297 15.668L83.875 13.7812L80.293 15.668C79.6641 15.9961 78.8984 15.4492 79.0078 14.7383L79.6914 10.7734L76.8203 7.95703C76.3008 7.4375 76.5742 6.5625 77.2852 6.45312L81.3047 5.87891L83.082 2.24219Z"
                      fill="#FCAF3D"
                    />
                    <defs>
                      <clipPath id="clip0_1232_2450">
                        <rect
                          width="24"
                          height="18"
                          fill="white"
                          transform="translate(99)"
                        />
                      </clipPath>
                    </defs>
                  </svg>

                  <div>
                    ₹{" "}
                    {Intl.NumberFormat("en-IN").format(
                      property?.expectedMonthlyRent
                    )}
                  </div>
                </div>
                {property.featured && (
                  <span
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      backgroundColor: "#B90000",
                      color: "#fff",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      fontSize: "12px",
                    }}
                  >
                    Featured
                  </span>
                )}
              </div>
              <CardContent style={{ flexGrow: 1, paddingBottom: "0px" }}>
                {" "}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="truncate-2-lines"
                >
                  <Typography
                    variant="h6"
                    style={{
                      color: "",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                    className="truncate-2-lines"
                  >
                    {property.title || "1 BHK"}
                  </Typography>
                </div>
                <p
                  style={{
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                    fontSize: "12px",
                    color: "#8A909A ",
                  }}
                >
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 1.27686C6.19792 1.27686 5.44141 1.4318 4.73047 1.7417C4.02865 2.05159 3.41341 2.47087 2.88477 2.99951C2.35612 3.52816 1.93685 4.14339 1.62695 4.84521C1.31706 5.55615 1.16211 6.31266 1.16211 7.11475C1.16211 8.19027 1.4401 9.2111 1.99609 10.1772C2.55208 11.1434 3.16732 11.991 3.8418 12.7202C4.51628 13.4494 5.14062 14.0327 5.71484 14.4702C6.29818 14.9077 6.60807 15.1401 6.64453 15.1675C6.70833 15.1948 6.76986 15.2199 6.8291 15.2427C6.88835 15.2655 6.94531 15.2769 7 15.2769C7.05469 15.2769 7.11165 15.2655 7.1709 15.2427C7.23014 15.2199 7.29167 15.1948 7.35547 15.1675C7.39193 15.1401 7.70182 14.9077 8.28516 14.4702C8.85938 14.0327 9.48372 13.4494 10.1582 12.7202C10.8327 11.991 11.4479 11.1434 12.0039 10.1772C12.5599 9.2111 12.8379 8.19027 12.8379 7.11475C12.8379 6.31266 12.6829 5.55615 12.373 4.84521C12.0632 4.14339 11.6439 3.52816 11.1152 2.99951C10.5866 2.47087 9.97135 2.05159 9.26953 1.7417C8.55859 1.4318 7.80208 1.27686 7 1.27686ZM7 13.9917C6.72656 13.7912 6.32552 13.4676 5.79688 13.021C5.27734 12.5744 4.76237 12.0457 4.25195 11.4351C3.74154 10.8244 3.29492 10.1453 2.91211 9.39795C2.5293 8.65967 2.33789 7.8986 2.33789 7.11475C2.33789 6.47673 2.46094 5.87061 2.70703 5.29639C2.95312 4.73128 3.28581 4.23909 3.70508 3.81982C4.12435 3.40055 4.61654 3.06787 5.18164 2.82178C5.75586 2.57568 6.36198 2.45264 7 2.45264C7.63802 2.45264 8.24414 2.57568 8.81836 2.82178C9.38346 3.06787 9.87565 3.40055 10.2949 3.81982C10.7142 4.23909 11.0469 4.73128 11.293 5.29639C11.5391 5.87061 11.6621 6.47673 11.6621 7.11475C11.6621 7.8986 11.4707 8.65967 11.0879 9.39795C10.7051 10.1453 10.2585 10.8244 9.74805 11.4351C9.23763 12.0457 8.72266 12.5744 8.20312 13.021C7.67448 13.4676 7.27344 13.7912 7 13.9917ZM7 4.77686C6.36198 4.77686 5.81283 5.007 5.35254 5.46729C4.89225 5.92757 4.66211 6.47673 4.66211 7.11475C4.66211 7.75277 4.89225 8.30192 5.35254 8.76221C5.81283 9.22249 6.36198 9.45264 7 9.45264C7.63802 9.45264 8.18717 9.22249 8.64746 8.76221C9.10775 8.30192 9.33789 7.75277 9.33789 7.11475C9.33789 6.47673 9.10775 5.92757 8.64746 5.46729C8.18717 5.007 7.63802 4.77686 7 4.77686ZM7 8.27686C6.68099 8.27686 6.40755 8.16292 6.17969 7.93506C5.95182 7.70719 5.83789 7.43376 5.83789 7.11475C5.83789 6.79574 5.95182 6.5223 6.17969 6.29443C6.40755 6.06657 6.68099 5.95264 7 5.95264C7.31901 5.95264 7.59245 6.06657 7.82031 6.29443C8.04818 6.5223 8.16211 6.79574 8.16211 7.11475C8.16211 7.43376 8.04818 7.70719 7.82031 7.93506C7.59245 8.16292 7.31901 8.27686 7 8.27686Z"
                      fill="#8A909A"
                    />
                  </svg>
                  <span className="truncate-2-lines">
                    {property?.locality?.coordinates[2]}
                  </span>
                </p>
                <Typography
                  style={{
                    fontSize: "14px",
                    marginBottom: "15px",
                  }}
                >
                  {property.location}
                </Typography>
                <div
                  style={{
                    backgroundColor: "#F6F4FF",
                    padding: "7px 10px",
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#7d8597",
                    fontSize: "12px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    alignItems: "center",
                    // height: "30px",
                  }}
                >
                  {property.bedrooms && (
                    <span>
                      <BedDoubleIcon
                        style={{ marginRight: "6px" }}
                        color="#b90000"
                        size={"15px"}
                      />
                      <span style={{ color: "black" }}>
                        {property.bedrooms}{" "}
                        {property.bedrooms === "1" ? "Room" : "Rooms"}
                      </span>
                    </span>
                  )}
                  {property?.bathroom && (
                    <span>
                      <Bathroom
                        style={{
                          marginRight: "6px",
                          color: "#b90000",
                          width: "16px",
                        }}
                        color="#b90000"
                        size={"15px"}
                      />
                      <span style={{ color: "black" }}>
                        {property.bathroom} Baths
                      </span>
                    </span>
                  )}
                  {property.buildupArea && (
                    <span>
                      <Business
                        style={{
                          marginRight: "6px",
                          color: "#b90000",
                          width: "16px",
                        }}
                        color="#b90000"
                        size={"13px"}
                      />
                      <span style={{ color: "black" }}>
                        {property.buildupArea} Sqft
                      </span>
                    </span>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "start",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {/* <img
                      src={Avatar}
                      alt="Agent"
                      style={{ width: '40px', height: '40px', borderRadius: '50%', marginRight: '10px' }}
                    /> */}
                    <div>
                      <p
                        style={{
                          textTransform: "capitalize",
                          color: "black",
                          fontSize: "small",
                          marginBottom: "0px",
                        }}
                      >
                        Listed By :{" "}
                        <span style={{ fontWeight: "600" }}>
                        {property.createdBy==="admin"? "GharWala exclusive": property.createdBy}
                        </span>
                      </p>
                      <p
                        style={{
                          fontSize: "small",
                        }}
                      >
                        Listed on:{" "}
                        <span style={{ fontWeight: "600" }}>
                          {
                            property?.created
                              ?.slice(0, 10)
                              ?.split("-") // Split the string into an array
                              ?.reverse() // Reverse the order
                              ?.join("-") // Join the array back into a string with "-" as the separator
                          }
                        </span>
                      </p>
                    </div>
                  </div>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      backgroundColor: "#B90000",
                      color: "#fff",
                      fontSize: "small",
                    }}
                    onClick={() =>
                      handleContact(
                        property?.route_title || property._id,
                        property
                      )
                    }
                  >
                    Book Now
                  </Button>
                </div>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Slider>
      {propertiesForRent.length > 6 && (
        <div style={{ marginTop: "2rem" }} className="blog-container-btn">
          <Link to={"/featured-properties"} className="view-all-blogs">
            View All Featured Properties
          </Link>
        </div>
      )}
    </section>




    <section style={{paddingTop:"10px"}} className="responsive-padding">
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <Typography variant="h4" style={{ color: "black", fontWeight: "bold" }}>
          Featured Properties for Rent
        </Typography>
        <Typography style={{ color: "#7d8597", fontSize: "16px" }}>
          Hand-Picked selection of quality places
        </Typography>
        
        <hr
          style={{
            borderBottom: "2px solid #B90000",
            width: "16px",
            margin: "0 auto",
            marginTop: "8px",
            borderRadius: "30px",
          }}
        />
      </div>

      <Slider autoplay {...settings}>
        {propertiesForRent.slice(0, 6).map((property) => (
          <Grid item key={property.id} xs={12} md={4} lg={4}>
            {" "}
            {/* Set consistent width */}
            <Card
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%", // Ensure card takes full height
                borderRadius: "10px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
                margin:"10px"
              }}
              onClick={() =>
                handleContact(property?.route_title || property._id, property)
              }
            >
              <div style={{ position: "relative" }}>
              <Watermark
                  gutter={60}
                  rotate={0}
                  text="Gharwalah.com"
                  textSize={20}
                  multiline={false}
                >
                <CardMedia
                  component="img"
                  image={property?.image}
                  // alt={
                  //   property?.title +
                  //   " " +
                  //   property?.propertyType +
                  //   " for " +
                  //   property?.wantto +
                  //   " " +
                  //   property?.locality?.coordinates[2]
                  // }
                  style={{
                    height: "200px",
                    objectFit: "cover",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }}
                />
                </Watermark>

                <div className="badge-chip">
                  <Chip
                    style={{
                      color: "white",
                      backgroundColor: "#b90000",
                      fontSize: "12px",
                    }}
                    label={property?.propertyType.toUpperCase()}
                  />
                </div>

                <div className="stars">
                  <svg
                    width="123"
                    height="18"
                    viewBox="0 0 123 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1232_2450)">
                      <path
                        d="M103.2 15.168C102.659 15.168 102.15 15.0747 101.674 14.888C101.198 14.692 100.783 14.4167 100.428 14.062C100.083 13.698 99.8307 13.2733 99.672 12.788L100.792 12.312C100.988 12.8253 101.305 13.2267 101.744 13.516C102.192 13.796 102.677 13.936 103.2 13.936C103.629 13.936 104.007 13.8427 104.334 13.656C104.67 13.46 104.931 13.194 105.118 12.858C105.305 12.5127 105.398 12.13 105.398 11.71C105.398 11.2713 105.3 10.884 105.104 10.548C104.917 10.212 104.661 9.95067 104.334 9.764C104.007 9.568 103.634 9.47 103.214 9.47C102.785 9.47 102.393 9.568 102.038 9.764C101.683 9.96 101.427 10.2073 101.268 10.506L100.162 10.268L100.96 4.57H106.364V5.76H101.478L102.01 5.228L101.394 9.652L100.918 9.372C101.226 8.98 101.585 8.7 101.996 8.532C102.416 8.35467 102.869 8.266 103.354 8.266C104.035 8.266 104.633 8.42 105.146 8.728C105.659 9.036 106.061 9.44667 106.35 9.96C106.639 10.4733 106.784 11.0567 106.784 11.71C106.784 12.3633 106.625 12.9513 106.308 13.474C106 13.9967 105.575 14.412 105.034 14.72C104.502 15.0187 103.891 15.168 103.2 15.168ZM109.167 15V13.32H110.525V15H109.167ZM117.152 15.168C116.322 15.168 115.594 14.944 114.968 14.496C114.352 14.0387 113.872 13.4087 113.526 12.606C113.181 11.794 113.008 10.8513 113.008 9.778C113.008 8.70467 113.181 7.76667 113.526 6.964C113.872 6.152 114.352 5.522 114.968 5.074C115.584 4.626 116.308 4.402 117.138 4.402C117.969 4.402 118.692 4.626 119.308 5.074C119.924 5.522 120.405 6.152 120.75 6.964C121.105 7.76667 121.282 8.70467 121.282 9.778C121.282 10.8513 121.11 11.794 120.764 12.606C120.419 13.418 119.934 14.048 119.308 14.496C118.692 14.944 117.974 15.168 117.152 15.168ZM117.152 13.894C117.712 13.894 118.198 13.726 118.608 13.39C119.019 13.0447 119.336 12.564 119.56 11.948C119.794 11.332 119.91 10.6087 119.91 9.778C119.91 8.94733 119.794 8.224 119.56 7.608C119.336 6.992 119.014 6.516 118.594 6.18C118.184 5.844 117.698 5.676 117.138 5.676C116.578 5.676 116.093 5.844 115.682 6.18C115.272 6.516 114.95 6.992 114.716 7.608C114.492 8.224 114.38 8.94733 114.38 9.778C114.38 10.5993 114.492 11.318 114.716 11.934C114.95 12.55 115.272 13.0307 115.682 13.376C116.102 13.7213 116.592 13.894 117.152 13.894Z"
                        fill="#8A909A"
                      />
                    </g>
                    <path
                      d="M7.08203 2.24219C7.41016 1.58594 8.33984 1.61328 8.64062 2.24219L10.4453 5.87891L14.4375 6.45312C15.1484 6.5625 15.4219 7.4375 14.9023 7.95703L12.0312 10.7734L12.7148 14.7383C12.8242 15.4492 12.0586 15.9961 11.4297 15.668L7.875 13.7812L4.29297 15.668C3.66406 15.9961 2.89844 15.4492 3.00781 14.7383L3.69141 10.7734L0.820312 7.95703C0.300781 7.4375 0.574219 6.5625 1.28516 6.45312L5.30469 5.87891L7.08203 2.24219Z"
                      fill="#FCAF3D"
                    />
                    <path
                      d="M26.082 2.24219C26.4102 1.58594 27.3398 1.61328 27.6406 2.24219L29.4453 5.87891L33.4375 6.45312C34.1484 6.5625 34.4219 7.4375 33.9023 7.95703L31.0312 10.7734L31.7148 14.7383C31.8242 15.4492 31.0586 15.9961 30.4297 15.668L26.875 13.7812L23.293 15.668C22.6641 15.9961 21.8984 15.4492 22.0078 14.7383L22.6914 10.7734L19.8203 7.95703C19.3008 7.4375 19.5742 6.5625 20.2852 6.45312L24.3047 5.87891L26.082 2.24219Z"
                      fill="#FCAF3D"
                    />
                    <path
                      d="M45.082 2.24219C45.4102 1.58594 46.3398 1.61328 46.6406 2.24219L48.4453 5.87891L52.4375 6.45312C53.1484 6.5625 53.4219 7.4375 52.9023 7.95703L50.0312 10.7734L50.7148 14.7383C50.8242 15.4492 50.0586 15.9961 49.4297 15.668L45.875 13.7812L42.293 15.668C41.6641 15.9961 40.8984 15.4492 41.0078 14.7383L41.6914 10.7734L38.8203 7.95703C38.3008 7.4375 38.5742 6.5625 39.2852 6.45312L43.3047 5.87891L45.082 2.24219Z"
                      fill="#FCAF3D"
                    />
                    <path
                      d="M64.082 2.24219C64.4102 1.58594 65.3398 1.61328 65.6406 2.24219L67.4453 5.87891L71.4375 6.45312C72.1484 6.5625 72.4219 7.4375 71.9023 7.95703L69.0312 10.7734L69.7148 14.7383C69.8242 15.4492 69.0586 15.9961 68.4297 15.668L64.875 13.7812L61.293 15.668C60.6641 15.9961 59.8984 15.4492 60.0078 14.7383L60.6914 10.7734L57.8203 7.95703C57.3008 7.4375 57.5742 6.5625 58.2852 6.45312L62.3047 5.87891L64.082 2.24219Z"
                      fill="#FCAF3D"
                    />
                    <path
                      d="M83.082 2.24219C83.4102 1.58594 84.3398 1.61328 84.6406 2.24219L86.4453 5.87891L90.4375 6.45312C91.1484 6.5625 91.4219 7.4375 90.9023 7.95703L88.0312 10.7734L88.7148 14.7383C88.8242 15.4492 88.0586 15.9961 87.4297 15.668L83.875 13.7812L80.293 15.668C79.6641 15.9961 78.8984 15.4492 79.0078 14.7383L79.6914 10.7734L76.8203 7.95703C76.3008 7.4375 76.5742 6.5625 77.2852 6.45312L81.3047 5.87891L83.082 2.24219Z"
                      fill="#FCAF3D"
                    />
                    <defs>
                      <clipPath id="clip0_1232_2450">
                        <rect
                          width="24"
                          height="18"
                          fill="white"
                          transform="translate(99)"
                        />
                      </clipPath>
                    </defs>
                  </svg>

                  <div>
                    ₹{" "}
                    {Intl.NumberFormat("en-IN").format(
                      property?.expectedMonthlyRent
                    )}
                  </div>
                </div>
                {property.featured && (
                  <span
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      backgroundColor: "#B90000",
                      color: "#fff",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      fontSize: "12px",
                    }}
                  >
                    Featured
                  </span>
                )}
              </div>
              <CardContent style={{ flexGrow: 1, paddingBottom: "0px" }}>
                {" "}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="truncate-2-lines"
                >
                  <Typography
                    variant="h6"
                    style={{
                      color: "",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                    className="truncate-2-lines"
                  >
                    {property.title || "1 BHK"}
                  </Typography>
                </div>
                <p
                  style={{
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                    fontSize: "12px",
                    color: "#8A909A ",
                  }}
                >
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 1.27686C6.19792 1.27686 5.44141 1.4318 4.73047 1.7417C4.02865 2.05159 3.41341 2.47087 2.88477 2.99951C2.35612 3.52816 1.93685 4.14339 1.62695 4.84521C1.31706 5.55615 1.16211 6.31266 1.16211 7.11475C1.16211 8.19027 1.4401 9.2111 1.99609 10.1772C2.55208 11.1434 3.16732 11.991 3.8418 12.7202C4.51628 13.4494 5.14062 14.0327 5.71484 14.4702C6.29818 14.9077 6.60807 15.1401 6.64453 15.1675C6.70833 15.1948 6.76986 15.2199 6.8291 15.2427C6.88835 15.2655 6.94531 15.2769 7 15.2769C7.05469 15.2769 7.11165 15.2655 7.1709 15.2427C7.23014 15.2199 7.29167 15.1948 7.35547 15.1675C7.39193 15.1401 7.70182 14.9077 8.28516 14.4702C8.85938 14.0327 9.48372 13.4494 10.1582 12.7202C10.8327 11.991 11.4479 11.1434 12.0039 10.1772C12.5599 9.2111 12.8379 8.19027 12.8379 7.11475C12.8379 6.31266 12.6829 5.55615 12.373 4.84521C12.0632 4.14339 11.6439 3.52816 11.1152 2.99951C10.5866 2.47087 9.97135 2.05159 9.26953 1.7417C8.55859 1.4318 7.80208 1.27686 7 1.27686ZM7 13.9917C6.72656 13.7912 6.32552 13.4676 5.79688 13.021C5.27734 12.5744 4.76237 12.0457 4.25195 11.4351C3.74154 10.8244 3.29492 10.1453 2.91211 9.39795C2.5293 8.65967 2.33789 7.8986 2.33789 7.11475C2.33789 6.47673 2.46094 5.87061 2.70703 5.29639C2.95312 4.73128 3.28581 4.23909 3.70508 3.81982C4.12435 3.40055 4.61654 3.06787 5.18164 2.82178C5.75586 2.57568 6.36198 2.45264 7 2.45264C7.63802 2.45264 8.24414 2.57568 8.81836 2.82178C9.38346 3.06787 9.87565 3.40055 10.2949 3.81982C10.7142 4.23909 11.0469 4.73128 11.293 5.29639C11.5391 5.87061 11.6621 6.47673 11.6621 7.11475C11.6621 7.8986 11.4707 8.65967 11.0879 9.39795C10.7051 10.1453 10.2585 10.8244 9.74805 11.4351C9.23763 12.0457 8.72266 12.5744 8.20312 13.021C7.67448 13.4676 7.27344 13.7912 7 13.9917ZM7 4.77686C6.36198 4.77686 5.81283 5.007 5.35254 5.46729C4.89225 5.92757 4.66211 6.47673 4.66211 7.11475C4.66211 7.75277 4.89225 8.30192 5.35254 8.76221C5.81283 9.22249 6.36198 9.45264 7 9.45264C7.63802 9.45264 8.18717 9.22249 8.64746 8.76221C9.10775 8.30192 9.33789 7.75277 9.33789 7.11475C9.33789 6.47673 9.10775 5.92757 8.64746 5.46729C8.18717 5.007 7.63802 4.77686 7 4.77686ZM7 8.27686C6.68099 8.27686 6.40755 8.16292 6.17969 7.93506C5.95182 7.70719 5.83789 7.43376 5.83789 7.11475C5.83789 6.79574 5.95182 6.5223 6.17969 6.29443C6.40755 6.06657 6.68099 5.95264 7 5.95264C7.31901 5.95264 7.59245 6.06657 7.82031 6.29443C8.04818 6.5223 8.16211 6.79574 8.16211 7.11475C8.16211 7.43376 8.04818 7.70719 7.82031 7.93506C7.59245 8.16292 7.31901 8.27686 7 8.27686Z"
                      fill="#8A909A"
                    />
                  </svg>
                  <span className="truncate-2-lines">
                    {property?.locality?.coordinates[2]}
                  </span>
                </p>
                <Typography
                  style={{
                    fontSize: "14px",
                    marginBottom: "15px",
                  }}
                >
                  {property.location}
                </Typography>
                <div
                  style={{
                    backgroundColor: "#F6F4FF",
                    padding: "7px 10px",
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#7d8597",
                    fontSize: "12px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    alignItems: "center",
                    // height: "30px",
                  }}
                >
                  {property.bedrooms && (
                    <span>
                      <BedDoubleIcon
                        style={{ marginRight: "6px" }}
                        color="#b90000"
                        size={"15px"}
                      />
                      <span style={{ color: "black" }}>
                        {property.bedrooms}{" "}
                        {property.bedrooms === "1" ? "Room" : "Rooms"}
                      </span>
                    </span>
                  )}
                  {property?.bathroom && (
                    <span>
                      <Bathroom
                        style={{
                          marginRight: "6px",
                          color: "#b90000",
                          width: "16px",
                        }}
                        color="#b90000"
                        size={"15px"}
                      />
                      <span style={{ color: "black" }}>
                        {property.bathroom} Baths
                      </span>
                    </span>
                  )}
                  {property.buildupArea && (
                    <span>
                      <Business
                        style={{
                          marginRight: "6px",
                          color: "#b90000",
                          width: "16px",
                        }}
                        color="#b90000"
                        size={"13px"}
                      />
                      <span style={{ color: "black" }}>
                        {property.buildupArea} Sqft
                      </span>
                    </span>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "start",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {/* <img
                      src={Avatar}
                      alt="Agent"
                      style={{ width: '40px', height: '40px', borderRadius: '50%', marginRight: '10px' }}
                    /> */}
                    <div>
                      <p
                        style={{
                          textTransform: "capitalize",
                          color: "black",
                          fontSize: "small",
                          marginBottom: "0px",
                        }}
                      >
                        Listed By :{" "}
                        <span style={{ fontWeight: "600" }}>
                          {property.createdBy==="admin"? "GharWala exclusive": property.createdBy}
                        </span>
                      </p>
                      <p
                        style={{
                          fontSize: "small",
                        }}
                      >
                        Listed on:{" "}
                        <span style={{ fontWeight: "600" }}>
                          {
                            property?.created
                              ?.slice(0, 10)
                              ?.split("-") // Split the string into an array
                              ?.reverse() // Reverse the order
                              ?.join("-") // Join the array back into a string with "-" as the separator
                          }
                        </span>
                      </p>
                    </div>
                  </div>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      backgroundColor: "#B90000",
                      color: "#fff",
                      fontSize: "small",
                    }}
                    onClick={() =>
                      handleContact(
                        property?.route_title || property._id,
                        property
                      )
                    }
                  >
                    Book Now
                  </Button>
                </div>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Slider>
      {propertiesForRent.length > 6 && (
        <div style={{ marginTop: "2rem" }} className="blog-container-btn">
          <Link to={"/featured-properties"} className="view-all-blogs">
            View All Featured Properties
          </Link>
        </div>
      )}
    </section>
    
    </>
  );
};

// Internal CSS styles object
const styles = {
  container: {
    padding: "100px",
    backgroundColor: "#23AEFF12",
  },
  header: {
    textAlign: "center",
    marginBottom: "20px",
  },
  title: {
    fontSize: "24px",
    color: "#1e2a78",
    fontWeight: "bold",
  },
  subtitle: {
    color: "#7d8597",
    fontSize: "16px",
  },
  separator: {
    borderBottom: "2px solid #B90000",
    width: "16px",
    margin: "0 auto",
    marginTop: "8px",
    borderRadius: "30px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "20px",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    transition: "transform 0.3s ease",
    cursor: "pointer",
    width: "350px",
    height: "auto",
  },
  imageContainer: {
    position: "relative",
  },
  image: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
  },
  featuredBadge: {
    position: "absolute",
    top: "10px",
    left: "10px",
    backgroundColor: "#B90000",
    color: "#fff",
    padding: "5px 10px",
    borderRadius: "5px",
    fontSize: "12px",
  },
  cardContent: {
    padding: "15px",
  },
  price: {
    color: "#1e2a78",
    fontSize: "18px",
    fontWeight: "bold",
  },
  rating: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },
  stars: {
    color: "#FFD700",
    marginRight: "5px",
  },
  excellent: {
    fontSize: "12px",
    color: "#7d8597",
  },
  propertyTitle: {
    color: "#1e2a78",
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "5px",
  },
  location: {
    color: "#7d8597",
    fontSize: "14px",
    marginBottom: "15px",
  },
  propertyDetails: {
    backgroundColor: "#F6F4FF",
    padding: "4px",
    display: "flex",
    justifyContent: "space-between",
    color: "#7d8597",
    fontSize: "12px",
    marginBottom: "15px",
  },
  agentSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "10px",
  },
  agentInfo: {
    display: "flex",
    alignItems: "center",
  },
  agentImage: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    marginRight: "10px",
  },
  agentName: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#1e2a78",
    marginTop: "10px",
  },
  agentLocation: {
    fontSize: "12px",
    color: "#7d8597",
  },
  bookNowButton: {
    backgroundColor: "#B90000",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    padding: "10px 20px",
    cursor: "pointer",
  },
};

export default FeaturedRent;
